import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { setEvent, setConnected, setError } from "@src/reducers/sse-slice";
import { useSSESubscription } from "@src/hooks/use-sse-subscription";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { useI18N } from "@src/language/language-context";

const SERVICE = "service-support";

export const useServiceSupportSSE = () => {
  const i18n = useI18N();
  const texts = {
    serviceSupportErrorText: i18n("modules.sse.serviceSupportErrorText"),
  };
  const dispatch = useDispatch();

  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const namespace = authContext?.customerNamespace;

  const baseURL = supportUrlEnvVar();

  useSSESubscription({
    url: `${baseURL}/api/v1/ns/${namespace}/events`,
    service: SERVICE,
    events: [
      {
        eventType: "ticket_updated",
        onEvent: (data) => {
          dispatch(
            setEvent({
              service: SERVICE,
              eventType: "ticket_updated",
              data,
            }),
          );
        },
      },
      {
        eventType: "ticket_created",
        onEvent: (data) => {
          dispatch(
            setEvent({
              service: SERVICE,
              eventType: "ticket_created",
              data,
            }),
          );
        },
      },
      {
        eventType: "comment_created",
        onEvent: (data) => {
          dispatch(
            setEvent({
              service: SERVICE,
              eventType: "comment_created",
              data,
            }),
          );
        },
      },
      {
        eventType: "ticket_ai_stream_saved",
        onEvent: (data) => {
          dispatch(
            setEvent({
              service: SERVICE,
              eventType: "ticket_ai_stream_saved",
              data,
            }),
          );
        },
      },
    ],

    onOpen: () => {
      dispatch(setConnected({ service: SERVICE, status: true }));
    },

    onError: () => {
      dispatch(setConnected({ service: SERVICE, status: false }));
      dispatch(
        setError({
          service: SERVICE,
          hasError: true,
          message: texts.serviceSupportErrorText,
        }),
      );
    },
  });
};
